import { MesaShell, MesaHeader, StatusNotice } from "../mesa-ui";
import "../mesa-ui/mesa-ui.css";

export default function MesaMissingToken() {
  return (
    <MesaShell>
      <MesaHeader table={null} cartCount={0} onToggleCart={() => {}} />
      <div className="mesa-hero">
        <h2>Bienvenido a NEON</h2>
        <p>Escanea el QR de tu mesa para ver la carta y pedir.</p>
      </div>
      <StatusNotice
        type="inactive"
        title="Código de mesa no detectado"
        message="Para usar la carta QR necesitas escanear el código de tu mesa. Pídele ayuda al camarero si no tienes el QR a mano."
      />
    </MesaShell>
  );
}
